/**
 * In-place Tabulator 5.5.2 column title update.
 * Column.updateDefinition({ title }) addColumn+delete, leaving Sort.sortList
 * pointing at a Column whose element is false → Sort.js:403 setAttribute crash.
 */

function isDomElement(el) {
  return !!(el && typeof el.setAttribute === 'function' && typeof el.querySelector === 'function');
}

function setTitleNodeText(titleEl, title) {
  const editor = titleEl.querySelector('input.tabulator-title-editor');
  if (editor) {
    editor.value = title;
    return;
  }
  const elementChildren = [];
  for (const node of titleEl.childNodes) {
    if (node.nodeType === 1) elementChildren.push(node);
  }
  if (elementChildren.length === 0) {
    titleEl.textContent = title;
    return;
  }
  for (const node of titleEl.childNodes) {
    if (node.nodeType === 3) {
      node.textContent = title;
      return;
    }
  }
  titleEl.insertBefore(titleEl.ownerDocument.createTextNode(title), titleEl.firstChild);
}

export function setTabulatorColumnTitle(col, title) {
  if (!col || title == null) return;
  const def = typeof col.getDefinition === 'function' ? col.getDefinition() : null;
  if (def && typeof def === 'object') def.title = title;
  const el = typeof col.getElement === 'function' ? col.getElement() : null;
  if (!isDomElement(el)) return;
  const titleEl = el.querySelector('.tabulator-col-title');
  if (!titleEl) return;
  setTitleNodeText(titleEl, title);
}

export function applyTabulatorColumnTitles(table, t, fieldKeys) {
  if (!table || typeof table.getColumns !== 'function' || typeof t !== 'function' || !fieldKeys) return;
  const columns = table.getColumns();
  for (const col of columns) {
    const field = typeof col.getField === 'function' ? col.getField() : null;
    const key = field ? fieldKeys[field] : null;
    if (!key) continue;
    try {
      setTabulatorColumnTitle(col, t(key));
    } catch (_) {
      /* keep live filters/sort/layout */
    }
  }
}
